import React, { Children } from 'react';
import { View } from 'react-native';

import type { XStyle } from '@savvy/deprecated-shared/theme/types';
import type { AlignItems, FlexDirection, JustifyContent } from '@savvy/deprecated-shared/types/css';

type Props = {
  readonly alignItems?: AlignItems;
  readonly children?: React.ReactNode;
  readonly direction?: FlexDirection;
  readonly display?: 'flex' | 'none';
  readonly flexGrow?: number;
  readonly flexShrink?: number;
  readonly justifyContent?: JustifyContent;
  readonly marginLeft?: number | 'auto';
  readonly marginRight?: number | 'auto';
  readonly spacing?: number;
  readonly style?: XStyle;
  readonly maxWidth?: number;
};

export function XStack({
  alignItems,
  children,
  direction = 'column',
  display = 'flex',
  flexGrow = 1,
  flexShrink,
  justifyContent,
  marginLeft,
  marginRight,
  spacing = 0,
  style,
  maxWidth,
}: Props) {
  const filteredChildren = Children.toArray(children);

  return (
    <View
      style={{
        alignItems,
        display,
        flexDirection: direction,
        flexGrow,
        flexShrink,
        justifyContent,
        marginLeft,
        marginRight,
        maxWidth,
        gap: spacing,
        ...style,
      }}
    >
      {filteredChildren.length > 0
        ? filteredChildren.map((child, i) => (
            <React.Fragment
              // eslint-disable-next-line react/no-array-index-key
              key={i}
            >
              {child}
            </React.Fragment>
          ))
        : null}
    </View>
  );
}
